import * as React from 'react';

import type * as api from '@gitbook/api-client';
import { Link, themedFonts, useCurrentTheme } from '@gitbook/react-uikit';

import { getContentKitURLString } from '../cache';
import { ContentKitTextStyleContext } from './ContentKitText';
import type { ContentKitElementProps } from './types';

export function ContentKitLink(
    props: ContentKitElementProps<api.ContentKitLink>
): React.ReactElement {
    const { element, localState } = props;
    const [, font] = useCurrentTheme(themedFonts);

    const textStyle = React.useContext(ContentKitTextStyleContext);

    const url = getContentKitURLString(element.target.url, localState);

    return (
        <Link kind="default" style={[textStyle ? undefined : font.Body]} url={url}>
            {element.children}
        </Link>
    );
}
